import { AdminSettingsResponse } from '../../../types';

export enum TabType {
  GENERAL = 'GENERAL',
  SSO_SETTINGS = 'SSO_SETTINGS',
  PWD_STRATEGY_SETTINGS = 'PWD_STRATEGY_SETTINGS'
}

export type UserPasswordData = {
  nameAndPwdSettings: AdminSettingsResponse;
  ssoSettings: AdminSettingsResponse;
  nameCase: AdminSettingsResponse;
  nameSync: AdminSettingsResponse;
};

export type TabProps = {
  userAndPwdSettings: UserPasswordData;
};

export type ssoFormData = {
  saml_idp_use_identity: boolean;
  identity_use_oidc: boolean;
  account_edit_comEmail_disable: boolean;
  account_edit_accountName_disable: boolean;
  identity_disable_local_login: boolean;
};

export type pwdStrategyFormData = {
  password_min_length: number;
  password_min_digits: number;
  password_min_chars: number;
  password_min_symbols: number;
  password_max_retry: number;
  password_validity: number;
  password_unique: boolean;
};

export type generalFormData = {
  single_sign_on: boolean;
  case_sensitive_login: boolean;
  account_synchronisation_email: boolean;
};
